import { render, staticRenderFns } from "./AddSkillCategoryPage.vue?vue&type=template&id=13e6a7ef&"
import script from "./AddSkillCategoryPage.vue?vue&type=script&lang=js&"
export * from "./AddSkillCategoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports